// extracted by mini-css-extract-plugin
var _1 = "CalendarGridMonthWeek-moduleweekNumber__H0jWJ";
export { _1 as "weekNumber" }
